import { registraGlobalComponents } from '@/app'

import VApp from './VApp.vue'

import KTopo from './KTopo/KTopo.vue'
import SearchTopo from './KTopo/SearchTopo.vue'

import NavBar from './NavBar/NavBar.vue'
import KMenu from './KMenu/KMenu.vue'
import KMenuItem from './KMenu/KMenuItem.vue'

registraGlobalComponents({
	VApp,

	KTopo,
	SearchTopo,

	NavBar,
	KMenu,
	KMenuItem,
})
